export default {
  chatWidget: {
    chatWithUs: 'Chatea con nosotros',
    welcomeTitle: '¡Bienvenido a Bookivo!',
    welcomeMessage: '¿Cómo podemos ayudarte hoy?',
    continueChat: 'Continuar chat',
    startConversation: 'Iniciar conversación',
    formTitle: 'Cuéntanos más sobre ti',
    namePlaceholder: 'Tu nombre',
    emailPlaceholder: 'Tu correo electrónico',
    phonePlaceholder: 'Tu número de teléfono',
    nameRequired: 'Por favor ingresa tu nombre',
    emailRequired: 'Por favor ingresa tu correo electrónico',
    emailInvalid: 'Por favor ingresa un correo electrónico válido',
    phoneRequired: 'Por favor ingresa tu número de teléfono',
    startChat: 'Iniciar chat',
    chatTitle: 'Chat de soporte',
    chatTitleNoAgent: 'Conectando...',
    endChat: 'Terminar chat',
    inputPlaceholder: 'Escribe tu mensaje...',
    greeting: 'Hola',
    greetingMessage: '¿Cómo puedo asistirte hoy?',
    emoji: 'Emoji',
    uploadImage: 'Subir imagen',
    sending: 'Enviando...',
    uploadFailed: 'Error al subir, por favor intenta de nuevo',
    fileTooLarge: 'El tamaño del archivo no puede exceder 10MB',
    invalidFileType: 'Solo se pueden subir archivos de imagen',
    sendFailed: 'Error al enviar el mensaje, por favor intenta de nuevo',
    imageSendFailed: 'Error al enviar la imagen, por favor intenta de nuevo',
    connectionLost: 'Conexión perdida, por favor cierra y reabre el chat',
    uploading: 'Subiendo imagen...',
    sessionEnded: 'Sesión finalizada',
    rating: {
      title: 'Gracias por usar nuestro servicio. ¡Califica tu experiencia!',
      satisfied: 'Satisfecho',
      dissatisfied: 'Insatisfecho',
      placeholder: 'Bienvenido a darnos sugerencias',
      submit: 'Enviar calificación',
      endChat: 'Terminar chat',
      backToChat: 'Volver al chat',
      success: '¡Gracias por tus comentarios!'
    }
  }
}
